import { useState } from "react";
import CountUp from "react-countup";
import personne from "../../images/icons/1.png";
import mairies from "../../images/icons/2.png";
import usine from "../../images/icons/3.png";
import eau from "../../images/icons/4.png";

import { ScrollCounter } from "../../lib/scrollView";

export interface StatisticHomeSectionProps {
  className?: string;
  img1?: string;
  img2?: string;
  img3?: string;
  img4?: string;
  title1?: string;
  title2?: string;
  title3?: string;
  title4?: string;
  val1?: string;
  val2?: number;
  val3?: number;
  val4?: number;
}

const StatisticHomeSection: React.FC<StatisticHomeSectionProps> = ({
  className,
  img1 = personne,
  img2 = mairies,
  img3 = usine,
  img4 = eau,
  title1 = "Habitants approvisionnées",
  title2 = "Communes concernées",
  title3 = "Usine de production d'eau",
  title4 = "de m³ distribués par an",
  val1 = "520K",
  val2 = 32,
  val3 = 1,
  val4 = 25,
}) => {
  const [counterOn, setCounterOn] = useState(false);

  const handleScrollTrigger = () => {
    setCounterOn(true);
  };

  return (
    <>
      <ScrollCounter onScrollCounter={handleScrollTrigger} />
      <div
        className={`relative p-12 bg-[#f0fafe] ${className}`}
        style={{
          zIndex: 0,
        }}
      >
        <div className={`text-3xl font-bold text-center text-black`}>
          AQUAVESC en chiffres
        </div>

        <div className="flex flex-col items-center justify-center m-5 md:space-x-6 xl:flex-row">
          <div className="text-white">
            {" "}
            <div className={`flex flex-col   items-center      `}>
              <div className="items-center gap-[12px] inline-flex flex-col relative flex-[0_0_auto]">
                <img
                  className="  relative w-[45px] h-[45px] "
                  alt="Calque"
                  src={img1}
                />
                <div
                  className={`w-fit font-bold text-primary  text-[70px] text-center whitespace-nowrap relative   tracking-[0] leading-[normal]`}
                >
                  {val1 === "520K" ? (
                    <>
                      {counterOn && (
                        <CountUp start={0} end={520} duration={5} />
                      )}
                      K
                    </>
                  ) : (
                    val1 === "92%" && (
                      <>
                        {">"}
                        {counterOn && (
                          <CountUp start={0} end={92} duration={5} />
                        )}
                        {"%"}
                      </>
                    )
                  )}
                </div>
              </div>
              <div className="relative w-[254px]   font-bold text-[#e3e3e3] text-[16px] text-center tracking-[0] leading-[normal]">
                <div className={` text-center text-primary`}>{title1}</div>
              </div>
            </div>
          </div>
          <div
            className={`lg:flex flex-col hidden md:hidden   items-center gap-[17px]  lg:h-48 md:border-r   lg:[border-right-style:solid] text-primary`}
          ></div>
          <div className="text-white">
            {" "}
            <div className={`flex flex-col mt-14 lg:mt-0  items-center      `}>
              <div className="items-center gap-[12px] inline-flex flex-col relative flex-[0_0_auto]">
                <img
                  className="relative w-[45px] h-[45px] "
                  alt="Calque"
                  src={img2}
                />
                <div
                  className={`w-fit font-bold text-primary  text-[70px] text-center whitespace-nowrap relative   tracking-[0] leading-[normal]`}
                >
                  {counterOn && <CountUp start={0} end={val2} duration={5} />}
                </div>
              </div>
              <div className="relative w-[254px]   font-bold text-[#e3e3e3] text-[16px] text-center tracking-[0] leading-[normal]">
                <div className={` text-center text-primary`}>{title2}</div>
              </div>
            </div>
          </div>

          <div
            className={`lg:flex flex-col hidden md:hidden   items-center gap-[17px]  lg:h-48 md:border-r   lg:[border-right-style:solid] text-primary `}
          ></div>

          <div className={`flex flex-col mt-14 lg:mt-0   items-center       `}>
            <div className="items-center gap-[12px] inline-flex flex-col relative flex-[0_0_auto]">
              <img
                className="  relative w-[45px] h-[45px]"
                alt="F"
                src={img3}
              />
              <div
                className={`w-fit font-bold text-primary }  text-[70px] text-center whitespace-nowrap relative   tracking-[0] leading-[normal]`}
              >
                {title3 === "Usine de production d'eau" ? (
                  <>
                    {counterOn && <CountUp start={0} end={val3} duration={5} />}
                  </>
                ) : (
                  <>
                    {"+"}
                    {counterOn && <CountUp start={0} end={val3} duration={5} />}
                    {"Km"}
                  </>
                )}
              </div>
            </div>
            <div className="relative w-[254px]   font-bold text-[#e3e3e3] text-[16px] text-center tracking-[0] leading-[normal]">
              <div className={` text-center text-primary `}>{title3}</div>
            </div>
          </div>

          <div
            className={`lg:flex flex-col hidden md:hidden   items-center gap-[17px]  lg:h-48 md:border-r   lg:[border-right-style:solid] text-primary `}
          ></div>

          <div className={`flex flex-col mt-14 lg:mt-0   items-center       `}>
            <div className="items-center gap-[12px] inline-flex flex-col   flex-[0_0_auto]">
              <img
                className="  relative w-[45px] h-[45px]"
                alt="F"
                src={img4}
              />
              <div
                className={`w-fit font-bold text-primary }  text-[70px] text-center whitespace-nowrap relative   tracking-[0] leading-[normal]`}
              >
                {title4 === "de m³ distribués par an" ? (
                  <>
                    {counterOn && <CountUp start={0} end={val4} duration={5} />}
                    M
                  </>
                ) : (
                  <>
                    {counterOn && <CountUp start={0} end={val4} duration={5} />}
                    C
                  </>
                )}
              </div>
            </div>
            <div className="relative w-[254px]   font-bold text-[#e3e3e3] text-[16px] text-center tracking-[0] leading-[normal]">
              <div className={` text-center text-primary `}>{title4}</div>
            </div>
          </div>
          <div
            className={`lg:flex flex-col hidden md:hidden   items-center gap-[17px]  lg:h-48 md:border-r   lg:[border-right-style:solid] text-primary `}
          ></div>
        </div>
      </div>
    </>
  );
};

export default StatisticHomeSection;
